// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"3bb7e847","453":"e9ad0205","482":"a14f1ec8","693":"00951997"}[chunkId] + ".chunk.js";
};